import { HeaderNavModel } from '../../../model/HeaderNav'
import { useLocalizationStore } from '../../../../localization/store/localization.store'
import { appRoutePath } from '../../../../router/util/app-route-path'
import { observer } from 'mobx-react-lite'
import { LINK_LABEL_CLASS_NAME, NavListItem } from '../../../../../component/common/original/molecule/NavListItem'
import { TranslatableText } from '../../../../localization/component/atom/TranslatableText'
import { mergeTranslationWithObjects } from '../../../../localization/util/localization.helper'
import { useUserStore } from 'src/feature/user/store/user.store'
import { DefaultSiteMap } from 'src/feature/user/model/SiteMap'
import { LocalizedString } from 'typesafe-i18n'
import { Icon } from '@mui/material'
import { iconMapping } from 'src/util/icon-mapping'
import { useTourSteps } from 'src/hook/useTourSteps'

export type MainLinksProps = {
  isOpen: boolean
}

export const MainLinks = observer(({ isOpen }: MainLinksProps) => {
  const { translation } = useLocalizationStore()
  const { sitemap } = useUserStore()
  const { getStepClass } = useTourSteps()

  const navLinks = {
    company: {
      label: sitemap?.modules.find(m => m.key === 'company')?.name || translation.components.header.companyDefaultLink() as LocalizedString,
      props: {
        link: appRoutePath.companyPage,
        hidden: true,
        icon: 'BusinessRoundedIcon',
        className: getStepClass('company'),
      },
    },
    myDashboard: {
      props: {
        link: appRoutePath.profileInfo,
        icon: 'PersonRoundedIcon',
        className: getStepClass('myDashboard'),
      },
    },
    myGrowth: {
      props: {
        link: appRoutePath.userDashboard,
        icon: 'DashboardRoundedIcon',
        className: getStepClass('myGrowth'),
      },
    },
    eLearning: {
      props: {
        link: appRoutePath.eLearning,
        icon: 'SchoolRoundedIcon',
      },
    },
    forum: {
      props: {
        link: appRoutePath.forum,
      },
    },
  }

  const nav = mergeTranslationWithObjects(translation.components.header.nav, navLinks) as unknown as HeaderNavModel
  const effectiveSitemap = {
    modules: [
      ...(DefaultSiteMap.modules || []), // Include DefaultSiteMap modules
      ...(sitemap?.modules || []), // Include sitemap modules
    ],
  }
  const list = Object.entries(nav).filter(n => effectiveSitemap.modules.some(m => m.key === n[0]))

  return (
    <>
      {list.map(([id, { label, props }]) => {
        return (
          <NavListItem
            key={id}
            textValue={label}
            isMain={true}
            {...props}
            sx={{ display: 'flex', alignItems: 'center', gap: 7 }}
          >
            <Icon
              sx={{
                fontSize: 16,
                height: 16,
                width: 16,
                color: 'text.primary',
                transition: 'color 0.3s ease',
              }}
              className={LINK_LABEL_CLASS_NAME}
              component={iconMapping[props.icon ? props.icon : 'CameraRoundedIcon']}
            />
            {isOpen && (
              <TranslatableText
                component={'p'}
                className={LINK_LABEL_CLASS_NAME}
                textValue={label}
                sx={{ transition: 'color 0.3s ease' }}
              />
            )}
          </NavListItem>
        )
      })}
    </>
  )
})
